var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"cursor":"pointer"},attrs:{"href":"javascript:void(0)"},on:{"click":_vm.onClick}},[_c('u',[_vm._v(_vm._s(_vm.data.titulo))])])}
var staticRenderFns = []

export { render, staticRenderFns }